/* tslint:disable */
/* eslint-disable */
/**
 * NORA Api
 *  ## Headers  ### X-App-Version  Remember to include the `X-App-Version` header in every request. This will verify that the app version works with this API version. The API will return a `X-Minimum-App-Version` header as well including the minimum app version that is supported by this API. The contents of the header are is a JSON encoded DTO, `VersionHeaderDTO`. 
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction, replaceWithSerializableTypeIfNeeded } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { ApiResult } from '../models';
// @ts-ignore
import type { RunSystemChecks200Response } from '../models';
// @ts-ignore
import type { SendEventPing200Response } from '../models';
// @ts-ignore
import type { SendPushTest200Response } from '../models';
/**
 * AdminSystemCheckApi - axios parameter creator
 */
export const AdminSystemCheckApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary runSystemChecks
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        runSystemChecks: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/nora/admin/system-check`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication keycloak required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "keycloak", [], configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary sendSystemCheckEventPing
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendEventPing: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/nora/admin/system-check/event-ping`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication keycloak required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "keycloak", [], configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary sendSystemCheckPushTest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendPushTest: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/nora/admin/system-check/push-test`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication keycloak required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "keycloak", [], configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AdminSystemCheckApi - functional programming interface
 */
export const AdminSystemCheckApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AdminSystemCheckApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary runSystemChecks
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async runSystemChecks(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RunSystemChecks200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.runSystemChecks(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminSystemCheckApi.runSystemChecks']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary sendSystemCheckEventPing
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sendEventPing(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SendEventPing200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sendEventPing(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminSystemCheckApi.sendEventPing']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary sendSystemCheckPushTest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sendPushTest(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SendPushTest200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sendPushTest(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminSystemCheckApi.sendPushTest']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AdminSystemCheckApi - factory interface
 */
export const AdminSystemCheckApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AdminSystemCheckApiFp(configuration)
    return {
        /**
         * 
         * @summary runSystemChecks
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        runSystemChecks(options?: RawAxiosRequestConfig): AxiosPromise<RunSystemChecks200Response> {
            return localVarFp.runSystemChecks(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary sendSystemCheckEventPing
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendEventPing(options?: RawAxiosRequestConfig): AxiosPromise<SendEventPing200Response> {
            return localVarFp.sendEventPing(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary sendSystemCheckPushTest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendPushTest(options?: RawAxiosRequestConfig): AxiosPromise<SendPushTest200Response> {
            return localVarFp.sendPushTest(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AdminSystemCheckApi - object-oriented interface
 */
export class AdminSystemCheckApi extends BaseAPI {
    /**
     * 
     * @summary runSystemChecks
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public runSystemChecks(options?: RawAxiosRequestConfig) {
        return AdminSystemCheckApiFp(this.configuration).runSystemChecks(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary sendSystemCheckEventPing
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public sendEventPing(options?: RawAxiosRequestConfig) {
        return AdminSystemCheckApiFp(this.configuration).sendEventPing(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary sendSystemCheckPushTest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public sendPushTest(options?: RawAxiosRequestConfig) {
        return AdminSystemCheckApiFp(this.configuration).sendPushTest(options).then((request) => request(this.axios, this.basePath));
    }
}

